import { ContractType, Country, PriceOption, PriceRange } from '@immosky/types';

interface PriceOptions {
  buy: PriceOption[];
  rent: PriceOption[];
}

export const INITIAL_PRICE_RANGE: PriceRange = {
  min: {
    text: '',
    value: 0,
  },
  max: {
    text: '',
    value: 0,
  },
};

const countrySpecificPriceOptions: { [country: string]: PriceOptions } = {
  ['CH']: {
    buy: [
      {
        text: `0`,
        value: 0,
      },
      {
        text: `100'000`,
        value: 100000,
      },
      {
        text: `200'000`,
        value: 200000,
      },
      {
        text: `300'000`,
        value: 300000,
      },
      {
        text: `400'000`,
        value: 400000,
      },
      {
        text: `500'000`,
        value: 500000,
      },
      {
        text: `600'000`,
        value: 600000,
      },
      {
        text: `700'000`,
        value: 700000,
      },
      {
        text: `800'000`,
        value: 800000,
      },
      {
        text: `900'000`,
        value: 900000,
      },
      {
        text: `1'000'000`,
        value: 1000000,
      },
      {
        text: `1'100'000`,
        value: 1100000,
      },
      {
        text: `1'200'000`,
        value: 1200000,
      },
      {
        text: `1'300'000`,
        value: 1300000,
      },
      {
        text: `1'400'000`,
        value: 1400000,
      },
      {
        text: `1'500'000`,
        value: 1500000,
      },
      {
        text: `1'600'000`,
        value: 1600000,
      },
      {
        text: `1'700'000`,
        value: 1700000,
      },
      {
        text: `1'800'000`,
        value: 1800000,
      },
      {
        text: `1'900'000`,
        value: 1900000,
      },
      {
        text: `2'000'000+`,
        value: Infinity,
      },
    ],
    rent: [
      {
        text: `0`,
        value: 0,
      },
      {
        text: `500`,
        value: 500,
      },
      {
        text: `1'000`,
        value: 1000,
      },
      {
        text: `1'500`,
        value: 1500,
      },
      {
        text: `2'000`,
        value: 2000,
      },
      {
        text: `2'500`,
        value: 2500,
      },
      {
        text: `3'000`,
        value: 3000,
      },
      {
        text: `3'500`,
        value: 3500,
      },
      {
        text: `4'000+`,
        value: Infinity,
      },
    ],
  },
  ['FR']: {
    buy: [
      {
        text: `0`,
        value: 0,
      },
      {
        text: `100 000`,
        value: 100000,
      },
      {
        text: `200 000`,
        value: 200000,
      },
      {
        text: `300 000`,
        value: 300000,
      },
      {
        text: `400 000`,
        value: 400000,
      },
      {
        text: `500 000`,
        value: 500000,
      },
      {
        text: `600 000`,
        value: 600000,
      },
      {
        text: `700 000`,
        value: 700000,
      },
      {
        text: `800 000`,
        value: 800000,
      },
      {
        text: `900 000`,
        value: 900000,
      },
      {
        text: `1 000 000`,
        value: 1000000,
      },
      {
        text: `1 100 000`,
        value: 1100000,
      },
      {
        text: `1 200 000`,
        value: 1200000,
      },
      {
        text: `1 300 000`,
        value: 1300000,
      },
      {
        text: `1 400 000`,
        value: 1400000,
      },
      {
        text: `1 500 000`,
        value: 1500000,
      },
      {
        text: `1 600 000`,
        value: 1600000,
      },
      {
        text: `1 700 000`,
        value: 1700000,
      },
      {
        text: `1 800 000`,
        value: 1800000,
      },
      {
        text: `1 900 000`,
        value: 1900000,
      },
      {
        text: `2 000 000`,
        value: 2000000,
      },
      {
        text: `2 000 000+`,
        value: Infinity,
      },
    ],
    rent: [
      {
        text: `0`,
        value: 0,
      },
      {
        text: `500`,
        value: 500,
      },
      {
        text: `1 000`,
        value: 1000,
      },
      {
        text: `1 500`,
        value: 1500,
      },
      {
        text: `2 000`,
        value: 2000,
      },
      {
        text: `2 500`,
        value: 2500,
      },
      {
        text: `3 000`,
        value: 3000,
      },
      {
        text: `3 000+`,
        value: Infinity,
      },
    ],
  },
};

export function getPriceOptionsForContractType(
  countries: Country[],
  contractType: ContractType
): PriceOption[] {
  let priceOptions = countrySpecificPriceOptions['CH'];

  if (countries.indexOf('FR') > -1) {
    priceOptions = countrySpecificPriceOptions['FR'];
  }

  switch (countries && contractType) {
    case 'buy':
      return priceOptions.buy;
    case 'rent':
      return priceOptions.rent;
  }
}
